const TOC_NAV_ITEMS = {
    scheduleNav: {
        anchor: '#upcoming-trips-section',
        text: 'tocLinkSchedule',
    },
    overviewNav: {
        anchor: '#quickview-title-section',
        text: 'tocLinkJourney',
    },
    reviewNav: {
        anchor: '#carrier-review-section',
        text: 'tocLinkReview',
    },
    carrierSectionNav: {
        anchor: '#carrier-section',
        text: 'tocLinkCarrier',
    },
    priceSectionNav: {
        anchor: '#price-chart-header',
        text: 'tocLinkPrice',
    },
    faqNav: {
        anchor: '#faq-header-section',
        text: 'tocLinkFAQ',
    },
    cityBlurbNav: {
        anchor: '#city-editorial-blurb',
        text: 'tocLinkCity',
    },
    stationBlurbNav: {
        anchor: '#station-editorial-blurb',
        text: 'tocLinkStation',
    },
    relatedReadingsNav: {
        anchor: '#blog-section',
        text: 'tocBlog',
    },
    appNav: {
        anchor: '#gta-intro-section',
        text: 'tocLinkApp',
    },
};

export {
    TOC_NAV_ITEMS,
};
